/* eslint-disable */
export default {
  doNotCall: 'Nicht anrufen',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
